<template>
  <v-container grid-list-xl fluid>
    <v-layout row wrap>
      <compliance-control></compliance-control>
      <compliance-view></compliance-view>
    </v-layout>
  </v-container>
</template>

<script>
import Store from "@/store/computed/storeHelpers";
import ComplianceControl from "@/modules/complianceResources/complianceControl";
import ComplianceView from "@/modules/complianceResources/complianceView";

export default {
  components: {
    ComplianceControl,
    ComplianceView
  },
  computed: {
    // model: Store.getSet({ store: 'compliance', prop: 'model' }),
  }
};
</script>

<style scoped>
.list-complete-item {
  transition: all 1s;
  display: inline-block;
  margin-right: 10px;
}
.list-complete-enter, .list-complete-leave-to
        /* .list-complete-leave-active below version 2.1.8 */ {
  opacity: 0;
  transform: translateY(30px);
}
.list-complete-leave-active {
  position: absolute;
}
</style>
